import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Login() {
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSuccess = async (credentialResponse) => {
    setLoading(true);
    setError('');
    
    const result = await login(credentialResponse.credential);
    
    if (!result.success) {
      setError(result.error || 'Login failed. Please try again.');
    }
    
    setLoading(false);
  };

  const handleError = () => {
    setError('Google login failed. Please try again.');
  };

  return (
    <div className="login-page sodel-login">
      <div className="login-background">
        <div className="glow-orb orb-1"></div>
        <div className="glow-orb orb-2"></div>
        <div className="grid-pattern"></div>
      </div>
      
      <div className="login-container">
        <Link to="/" className="login-back-link">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to home
        </Link>
        
        <div className="login-card glass-card">
          <div className="login-brand">
            <div className="logo-icon">S</div>
            <div className="login-brand-text">
              <h1>Sodel HRMS</h1>
              <p>HR Management</p>
            </div>
          </div>
          
          <div className="login-divider">
            <span>Sign in to continue</span>
          </div>
          
          {error && (
            <div className="login-error">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {error}
            </div>
          )}
          
          {loading ? (
            <div className="login-loading">
              <div className="spinner-modern"></div>
              <p>Authenticating...</p>
            </div>
          ) : (
            <div className="login-button-container">
              <GoogleLogin
                onSuccess={handleSuccess}
                onError={handleError}
                text="signin_with"
                size="large"
                shape="rectangular"
                theme="filled_blue"
              />
            </div>
          )}
          
          <p className="login-hint">
            Use your @sodelsolutions.com Google account
          </p>
        </div>
        
        <div className="login-footer">
          <p>© {new Date().getFullYear()} Sodel Solutions Pvt. Ltd.</p>
          <p className="login-footer-links">
            <a href="https://www.sodelsolutions.com" target="_blank" rel="noopener noreferrer">
              sodelsolutions.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
